<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                    @closeRicerca="closeRicerca"
                    @changeValueOrClick="changeValueOrClick"
                    @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import {bus} from '../../../Bus.js'

  export default {
    name: 'RicercaAS',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            filtri: 'Filtri',
            statoNazione: 'Stato',
            codForn: 'Codice Fornitore',
            societa: 'Società',
            stabilimento: 'Stabilimento',
            anno: 'Anno',
            nrOrdine: 'Nr. Ordine',
            cerca: 'Cerca',
            scegli: 'Scegli...',
            attivi: 'Solo Ordini Attivi',
            Y: 'Si',
            N: 'No',
          }
        },
        fr_FR: {
          ricerca: {
            filtri: 'Filtres',
            statoNazione: 'Pays',
            codForn: 'Code du Fournisseur',
            societa: 'Société',
            stabilimento: 'Usine',
            anno: 'Année',
            nrOrdine: 'Nr. commande',
            cerca: 'Recherche',
            scegli: 'Choisir...',
            attivi: 'Seulement les Commandes Actives',
            Y: 'Si',
            N: 'No',
          }
        },
        es_ES: {
          ricerca: {
            filtri: 'Filtros',
            statoNazione: 'País',
            codForn: 'Código de Proveedor',
            societa: 'Empresa',
            stabilimento: 'Fábrica',
            anno: 'Año',
            nrOrdine: 'Nr. Pedido',
            cerca: 'Búsqueda',
            scegli: 'Elegir...',
            attivi: 'Solo Pedidos Activos',
            Y: 'Si',
            N: 'No',
          }
        },
        de_DE: {
          ricerca: {
            filtri: 'Filter',
            statoNazione: 'Land',
            codForn: 'Lieferantencode',
            societa: 'Unternehmen',
            stabilimento: 'Werk',
            anno: 'Jahr',
            nrOrdine: 'Bestellnummer',
            cerca: 'Suche',
            scegli: 'Wählen...',
            attivi: 'Nur Aktive Bestellungen',
            Y: 'Si',
            N: 'No',
          }
        },
        en_GB: {
          ricerca: {
            filtri: 'Filters',
            statoNazione: 'Country',
            codForn: 'Supplier Code',
            societa: 'Society',
            stabilimento: 'Establishment',
            anno: 'Year',
            nrOrdine: 'Nr. Order',
            cerca: 'Search',
            scegli: 'Choose...',
            attivi: 'Only Active Orders',
            Y: 'Si',
            N: 'No',
          }
        }
      }
    },
    props: {
      prefixApp: {
        type: String
      }
    },
    data () {
      return {
        codLang: sessionStorage.getItem('codLang'),
        codForn: '',
        codFornAdmin: {},
        filtriRicerca: {
          loading: true,
          titolo: '',
          valueSelected: {
            0: '',
            1: {},
            2: '',
            3: '',
            4: '',
            5: '',
            6: ''
          },
          dati: {
            0: [],
            1: [],
            2: [],
            3: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select con i fornitori
            {
              type: 'select-with-object',
              myLabel: '',
              value: '',
              label: ['codForn', 'desForn'],
              key: 'codForn',
              onChangeOrClick: 'changeCodForn',
              ifClearable: false,
              ifDisabled: false,
              ifShow: false
            },
            // Select con le Società
            {
              type: 'select',
              myLabel: '',
              value: 'codSoc',
              label: 'desSoc',
              key: 'codSoc',
              onChangeOrClick: 'changeSocieta',
              ifClearable: true,
              ifDisabled: true
            },
            {
              type: 'select',
              myLabel: '',
              value: 'codMag',
              label: 'desMag',
              key: 'codMag',
              ifClearable: true,
              ifDisabled: true
            },
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: true,
              typePicker: 'year',
              format: 'yyyy',
              valueFormat: 'yyyy'
            },
            {
              type: 'input',
              myLabel: '',
              ifClearable: true
            },
            // Solo Ordini Attivi
            {
              type: 'select',
              myLabel: '',
              value: 'value',
              label: 'label',
              key: 'value',
              ifClearable: false,
              ifDisabled: false
            },
          ]
        }
      }
    },
    /*
    mounted: function () {
      this.init()
    },
    */
    activated: function () {
      this.init()
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.$nextTick(() => {
          this.setTraduzioniLabel()
          this.getCountries(true)
          let obj = [{
            value: 'Y',
            label: this.$i18n.messages[this.codLang].attivi.Y
          }, {
            value: 'N',
            label: this.$i18n.messages[this.codLang].attivi.N
          }]
          this.$set(this.filtriRicerca.dati, 6, obj)
        })
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.$set(this.filtriRicerca.valueSelected, 1, {})
          this.$set(this.filtriRicerca.valueSelected, 2, '')
          this.$set(this.filtriRicerca.valueSelected, 3, '')
          this.$set(this.filtriRicerca.valueSelected, 4, '')
          this.$set(this.filtriRicerca.valueSelected, 5, '')
          this.$set(this.filtriRicerca.valueSelected, 6, '')
          this.$set(this.filtriRicerca.dati, 1, [])
          this.$set(this.filtriRicerca.dati, 2, [])
          this.$set(this.filtriRicerca.dati, 3, [])
          this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
          this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)
  
          if (this.codForn) {
            this.getSocieta()
          }
        }
      })
    },
    methods: {
      init: function () {
        this.$store.dispatch('ifObject', 'ASD_Ricerca').then((ifRicerca) => {
          // Se è salvata in VUEX una ricerca la reimposto
          if (ifRicerca) {
            let form = this.$store.state.ASD_Ricerca
            this.$set(this.filtriRicerca.valueSelected, 0, form.country)
            this.$set(this, 'codForn', form.codForn)
            let fornObj = {
              codForn: form.codForn,
              desForn: ''
            }
            this.$set(this.filtriRicerca.valueSelected, 1, fornObj)
            this.$set(this.filtriRicerca.valueSelected, 2, form.codSoc)
            this.$set(this.filtriRicerca.valueSelected, 3, form.codMag)
            this.$set(this.filtriRicerca.valueSelected, 4, form.annoOrd)
            this.$set(this.filtriRicerca.valueSelected, 5, form.numOrd)
            this.$set(this.filtriRicerca.valueSelected, 6, form.attivi)
          } else {
            this.$set(this.filtriRicerca.valueSelected, 0, '')
            this.$set(this.filtriRicerca.valueSelected, 1, {})
            this.$set(this.filtriRicerca.valueSelected, 2, '')
            this.$set(this.filtriRicerca.valueSelected, 3, '')
            this.$set(this.filtriRicerca.valueSelected, 4, '')
            this.$set(this.filtriRicerca.valueSelected, 5, '')
            this.$set(this.filtriRicerca.valueSelected, 6, '')
          }

          // Se esiste nel localStorage l'oggetto amministrazione lo setto
          if (localStorage.hasOwnProperty('amministrazione')) {
            this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          }

          // Chiamo il servizio per la lista degli Stati a cui sono abilitato passando come parametro false (NON sto cambiando lingua)
          this.getCountries(false)
  
          this.$nextTick(() => {
            let obj = [{
              value: 'Y',
              label: this.$i18n.messages[this.codLang].ricerca.Y
            }, {
              value: 'N',
              label: this.$i18n.messages[this.codLang].ricerca.N
            }]
            this.$set(this.filtriRicerca.dati, 6, obj)
            this.$set(this.filtriRicerca.valueSelected, 6, 'Y')
  
            // Chiamo il metodo per settare le traduzioni delle label nella lingua impostata
            this.setTraduzioniLabel()
          })
        })
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.statoNazione'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.codForn'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.societa'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.stabilimento'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.anno'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.nrOrdine'))
        this.$set(this.filtriRicerca.filtri[6], 'myLabel', this.$t('ricerca.attivi'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      cerca: function () {
        let form = {
          country: this.filtriRicerca.valueSelected[0],
          codForn: this.codForn,
          codSoc: this.filtriRicerca.valueSelected[2] ? this.filtriRicerca.valueSelected[2] : '',
          codMag: this.filtriRicerca.valueSelected[3] ? this.filtriRicerca.valueSelected[3] : '',
          annoOrd: this.filtriRicerca.valueSelected[4] ? this.filtriRicerca.valueSelected[4] : '',
          numOrd: this.filtriRicerca.valueSelected[5] ? this.filtriRicerca.valueSelected[5] : '',
          attivi: this.filtriRicerca.valueSelected[6] ? this.filtriRicerca.valueSelected[6] : ''
        }
        // this.$store.commit('set', {key: 'ASD_Ricerca', value: form})
        this.$emit('cerca', JSON.stringify(form))
      },
      changeValueOrClick: function (index, value) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick](value)
        }
      },
      getCountries: function (ifChangeLang) {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebAssociaDip'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 0, data)
              if (data.length > 0) {
                this.$store.dispatch('ifObject', 'ASD_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca già salvata in VUEX
                  if (!ifRicerca) {
                    // Verifico se lo Stato impostato nel localStorage esiste tra quelli restituiti dal servizio delle abilitazioni
                    let flag = data.some(e => e.country === localStorage.getItem('ACCSTA_country'))
                    // Se flag = true uso lo Stato del localStorage
                    this.$set(this.filtriRicerca.valueSelected, 0, flag ? localStorage.getItem('ACCSTA_country') : data[0].country)
                  }
  
                  // Se NON sto cambiando lingua procedo, altrimenti tolgo il loader
                  if (!ifChangeLang) {
                    this.getFornitoreInfo(false)
                  } else {
                    this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al momento del cambio della country vengono azzerati array e valori in modo da ricominciare
       il flusso delle funzioni dalla getFornitoreInfo
       */
      changeCountry: function () {
        this.$set(this.filtriRicerca.dati, 1, [])
        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.valueSelected, 1, {})
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        this.$set(this.filtriRicerca.valueSelected, 4, '')
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)

        this.$store.commit('set', {key: 'DIP_Ricerca', value: {}})
        this.$store.commit('set', {key: 'DIP_Dipendente', value: {}})
        this.$store.commit('set', {key: 'DIP_new', value: false})
        this.$store.commit('set', {key: 'DIP_Documento', value: {}})
        this.$store.commit('set', {key: 'DOC_Ricerca', value: {}})
        this.$store.commit('set', {key: 'GA_Documento', value: {}})
        this.$store.commit('set', {key: 'ASD_Ricerca', value: {}})
        sessionStorage.removeItem('ACCSTA_fornitore')

        // Se esiste l'oggetto amministrazione prendo il codForn ACCSTA del nuovo Stato
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
        }
        this.getFornitoreInfo(true)
      },
      /*  ifCodFornValorizzato = TRUE solo se getSocieta viene richiamata con il codForn !== ''
          ifRicerca = TRUE solo se il flusso delle funzioni deve terminare con la ricerca effettiva
       */
      getSocieta: function (ifChangeCountry ) {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('associadipendenti/societa', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codForn: this.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 2, data)
              this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', false)
              let codSoc = this.filtriRicerca.valueSelected[2]
              if (data.length > 0 && codSoc) {
                this.getMagazzini()
              } else {
                this.$store.dispatch('ifObject', 'ASD_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca salvata in VUEX oppure sto cambiando Stato
                  if (!ifRicerca) {
                    // Se NON sto cambiando stato effettuo la ricerca
                    if (!ifChangeCountry) {
                      this.cerca()
                    }
                  } else {
                    this.$emit('loadingOff')
                  }
                  this.$set(this.filtriRicerca, 'loading', false)
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      /*  Al cambio della società viene richiamata la getMagazzini solo nel caso in cui si sia solo modificato il codSoc
       e non cancellato, altrimenti vengono azzerati l'array dei magazzini e il codMag
       */
      changeSocieta: function () {
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        if (this.filtriRicerca.valueSelected[2]) {
          this.getMagazzini()
        } else {
          this.$set(this.filtriRicerca.dati, 3, [])
          this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)
        }
      },
      getMagazzini: function () {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('associadipendenti/magazzini', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0],
            codSoc: this.filtriRicerca.valueSelected[2],
            codForn: this.codForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this.filtriRicerca.dati, 3, data)
              if (data.length > 0) {
                this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', false)
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this.filtriRicerca, 'loading', false)
          })
      },
      getFornitoreInfo: function (ifChangeCountry) {
        this.$set(this.filtriRicerca, 'loading', true)
        this.$http.get('associadipendenti/info', {
          params: {
            codLang: this.codLang,
            country: this.filtriRicerca.valueSelected[0]
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              // Se utente è FORNITORE o AGENTE
              if (response.body.attrib.typeOfUser !== 'admin') {
                let data = response.body.data
                this.$set(this.filtriRicerca.dati, 1, data)
                this.$set(this.filtriRicerca.filtri[1], 'ifDisabled', (data.length <= 1))
                this.$set(this.filtriRicerca.filtri[1], 'ifShow', true)

                this.$store.dispatch('ifObject', 'ASD_Ricerca').then((ifRicerca) => {
                  // Se NON c'è una ricerca salvata in VUEX oppure sto cambiando Stato
                  if (!ifRicerca || ifChangeCountry) {
                    // Se esiste un codForn ACCSTA salvato
                    if (sessionStorage.hasOwnProperty('ACCSTA_fornitore')) {
                      let ACCSTA_fornitore = sessionStorage.getItem('ACCSTA_fornitore')
                      let flag = false
                      data.forEach((forn) => {
                        if (forn.codForn === ACCSTA_fornitore) {
                          flag = true
                          this.$set(this.filtriRicerca.valueSelected, 1, forn)
                          this.$set(this, 'codForn', forn.codForn)
                        }
                      })
                      if (!flag) {
                        this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                        this.$set(this, 'codForn', data[0].codForn)
                      }
                    }
                    // Se NON esiste un codForn ACCSTA salvato
                    else {
                      this.$set(this.filtriRicerca.valueSelected, 1, data[0])
                      this.$set(this, 'codForn', data[0].codForn)
                    }
                  }
  
                  if (this.codForn) {
                    this.getSocieta(ifChangeCountry)
                  } else {
                    this.$emit('loadingOff')
                    this.$set(this.filtriRicerca, 'loading', false)
                  }
                })
              }
              // Utente AMMINISTRATORE
              else {
                // Se esiste l'oggetto amministrazione e il codForn ACCSTA per lo Stato selezionato è valorizzato allora lo uso
                if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]]) {
                  this.$set(this, 'codForn', this.codFornAdmin.ACCSTA[this.filtriRicerca.valueSelected[0]])
                }

                this.$set(this.filtriRicerca.filtri[1], 'ifShow', false)
                if (this.codForn) {
                  this.getSocieta(ifChangeCountry)
                } else {
                  this.$emit('loadingOff')
                  this.$set(this.filtriRicerca, 'loading', false)
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this.filtriRicerca, 'loading', false)
            }
          })
      },
      changeCodForn: function () {
        this.$set(this, 'codForn', this.filtriRicerca.valueSelected[1].codForn)

        this.$set(this.filtriRicerca.dati, 2, [])
        this.$set(this.filtriRicerca.dati, 3, [])
        this.$set(this.filtriRicerca.valueSelected, 2, '')
        this.$set(this.filtriRicerca.valueSelected, 3, '')
        this.$set(this.filtriRicerca.valueSelected, 4, '')
        this.$set(this.filtriRicerca.valueSelected, 5, '')
        this.$set(this.filtriRicerca.filtri[2], 'ifDisabled', true)
        this.$set(this.filtriRicerca.filtri[3], 'ifDisabled', true)
  
        this.getSocieta()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

   .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/AssociaDipendenti/Ricerca.vue